import { render, staticRenderFns } from "./ProformCategoryFilter.vue?vue&type=template&id=0577abd3&scoped=true"
import script from "./ProformCategoryFilter.vue?vue&type=script&lang=js"
export * from "./ProformCategoryFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0577abd3",
  null
  
)

export default component.exports